import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { chaveDeErro } from "./chaveDeErro";
import { textoDeErro } from "./textoDeErro";

const toastError = err => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	// O código inteiro manda; o prefixo antes de ":" é a segunda tentativa, e
	// só quando ELE tem tradução. Cortar sempre apagava a metade legível de
	// mensagens como "ERR_WAHA: sessão parada".
	const chave = chaveDeErro(errorMsg, nome =>
		i18n.exists(`backendErrors.${nome}`)
	);

	if (errorMsg) {
		if (chave) {
			toast.error(i18n.t(`backendErrors.${chave}`, {
				...err.response?.data?.detalhes,
				interpolation: { escapeValue: false },
			}), {
				toastId: chave,
			});
		} else {
			toast.error(textoDeErro(errorMsg), {
				toastId: errorMsg,
			});
		}
	} else {
		// Sem código não havia toastId, e a tela de atendimentos monta quatro
		// listas de uma vez: uma queda de rede empilhava quatro avisos iguais.
		toast.error("Ocorreu um erro. Verifique sua conexão e tente de novo.", {
			toastId: "erro-sem-codigo",
		});
	}
};

export default toastError;
